import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CTAFinal() {
  const { t } = useTranslation('reparation');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="cta-final" className="bg-copper py-16 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-6 lg:px-10 text-center">
        <h2
          className={`font-manrope font-bold text-white text-2xl md:text-3xl lg:text-4xl mb-4 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {t('cta_h2')}
        </h2>
        <p
          className={`text-white/80 text-base md:text-lg mb-8 md:mb-10 max-w-2xl mx-auto transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {t('cta_subtitle')}
        </p>

        <div
          className={`flex flex-col sm:flex-row gap-4 justify-center transition-all duration-1000 delay-200 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <button
            onClick={() => {
              const el = document.getElementById('quote-form');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-soft-gray text-copper font-bold px-8 py-4 rounded-md text-base transition-all duration-300 whitespace-nowrap"
          >
            {t('cta_button')}
            <i className="ri-arrow-right-line" />
          </button>
          <a
            href="tel:+14184769950"
            aria-label="Appeler Couvreur-Lévis.com au 418-476-9950"
            title="Cliquez pour appeler"
            className="inline-flex items-center justify-center gap-2 border-2 border-white text-white hover:bg-white hover:text-copper font-bold px-8 py-4 rounded-md text-base transition-all duration-300 whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {t('cta_phone')}
          </a>
        </div>
      </div>
    </section>
  );
}